module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main resources",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', [_c('p', {
    staticClass: "resources-title"
  }, [_vm._v(_vm._s(_vm.$t('r-title1')))]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "white-paper"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180419/Crait_Resource_03.png"),
      "alt": ""
    },
    on: {
      "click": _vm.download
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "click-to-download",
    attrs: {
      "src": require("../../assets/images/20180419/Crait_Resource_05.png"),
      "alt": ""
    },
    on: {
      "click": _vm.download
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "blogs"
  }, [_c('p', {
    staticClass: "resources-title"
  }, [_vm._v(_vm._s(_vm.$t('r-title2')))]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "blogs-part1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "blogs-right"
  }, [_c('p', {
    staticClass: "resources-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('subtitle1')))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "resources-third-title"
  }, [_vm._v(_vm._s(_vm.$t('detail1')))])]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "https://medium.com/@craitapp/introducing-crait-e3ac2c22d133",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('readmore1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "blogs-part2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "blogs-right"
  }, [_c('p', {
    staticClass: "resources-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('subtitle2')))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "resources-third-title"
  }, [_vm._v(_vm._s(_vm.$t('detail2')))])]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "https://medium.com/@craitapp/data-breach-trends-f77db653fd78",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('readmore1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "blogs-part3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "blogs-right"
  }, [_c('p', {
    staticClass: "resources-sub-title"
  }, [_vm._v(_vm._s(_vm.$t('subtitle3')))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "resources-third-title"
  }, [_vm._v(_vm._s(_vm.$t('detail3')))])]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "https://medium.com/@craitapp/small-enterprises-are-easy-targets-a48bd23856cb",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('readmore1')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "read-more-btn"
  }, [_c('a', {
    attrs: {
      "href": "https://medium.com/@craitapp",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('readmore2')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180419/Crait_Resource_09.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180419/Crait_Resource_12.jpeg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180419/Crait_Resource_14.jpeg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d05ac1ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/Resources.vue
// module id = 304
// module chunks = 1